import './LandingPage.css';

export default function DashboardSummary({ data, loading, error, onRetry }) {
  if (loading) {
    return (
      <div className="summary-grid">
        <div className="summary-card skeleton" />
        <div className="summary-card skeleton" />
        <div className="summary-card skeleton" />
      </div>
    );
  }

  if (error) {
    return (
      <div className="inline-message error">
        <span>{error}</span>
        {onRetry && (
          <button type="button" className="btn outline" onClick={onRetry}>
            Retry
          </button>
        )}
      </div>
    );
  }

  const members = data?.members ?? { total: 0, over_18: 0, with_contributions: 0 };
  const contributions = data?.contributions ?? { total_collected: 0, latest_member_total: 0 };

  return (
    <div className="summary-grid">
      <div className="summary-card">
        <h3>Total members</h3>
        <div className="value">{members.total}</div>
        <div className="meta">All members registered to your unit</div>
      </div>
      <div className="summary-card">
        <h3>Members aged 18+</h3>
        <div className="value">{members.over_18}</div>
        <div className="meta">Adults eligible for extended programs</div>
      </div>
      <div className="summary-card">
        <h3>Total collected</h3>
        <div className="value">₹{Number(contributions.total_collected || 0).toLocaleString()}</div>
        <div className="meta">Sadaqa collected from this unit</div>
      </div>
      <div className="summary-card">
        <h3>Members contributing</h3>
        <div className="value">{members.with_contributions ?? 0}</div>
        <div className="meta">Number of members with at least one contribution</div>
      </div>
    </div>
  );
}
